'use strict'

import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '@/router'
import appconfig from '@/configs/appConfig.js'
import { Message } from 'element-ui'

// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    // 携带UserToken到请求头

    // config.headers.common['Content-Type'] = "application/x-www-form-urlencoded"
    let token = store.getters.GetUserToken
    if (token) {
        config.headers.common['OF-Authorization'] = token
    }
    let requestUrl = appconfig.ApiPrefix + config.url

    if (requestUrl.indexOf('nocache') < 0) {
        if (requestUrl.indexOf('?') < 0) {
            requestUrl += '?'
        } else {
            requestUrl += '&'
        }
        requestUrl += 'nocache=' + new Date().getTime()
    }

    config.url = requestUrl
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    return response
}, function (error) {
    if(error && error.response) {
        let msg = '[' + error.response.status + ']错误' 
        switch(error.response.status) {
            case 401:
                if(error.response && error.response.data && error.response.data.Message) {
                    msg = msg + '：' + error.response.data.Message
                } else {
                    msg += '：授权票据无效或已失效，请重新登录'
                }
                Message({
                    showClose: true,
                    message: msg,
                    type: 'error'
                })
                store.commit('UPDATE_USERTOKEN','')
                router.push('/login')
                break
            case 403:
                router.push('/403')
                break
            default:
                if(error.response.status==404&&error.response.data=='物理文件不存在'){
                    return;
                }
                msg = '其它错误'
                if(error.response && error.response.data && error.response.data.Message) {
                    msg = msg + '：' + error.response.data.Message
                } else {
                    msg += '：其它错误'
                }
                Message({
                    showClose: true,
                    message: msg,
                    type: 'warning'
                })
       } 
    }
    // 对响应错误做点什么
    return Promise.reject(error)
})

Vue.prototype.$http = axios

export default axios

